var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: [_vm.$style.status, _vm.$style[_setup.statusWithIcon.type]]
  }, [_setup.statusWithIcon.icon ? _c('div', {
    class: _vm.$style.iconWrapper
  }, [_c(_setup.SIcon, {
    attrs: {
      "icon": _setup.statusWithIcon.icon,
      "size": "24"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.$style.label
  }, [_vm._v("\n    " + _vm._s(_setup.statusLabel) + "\n  ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };